// extracted by mini-css-extract-plugin
module.exports = {"candidate-card":"styles-module__candidate-card___xX2OS","cursor-move":"styles-module__cursor-move___3D0wI"};